module.exports = __webpack_public_path__ + "img/Woman-1.fd46e379.svg";